<script>

export default {
    name: 'dkbr-progress',
    props: {
        th: {
            name: 'th',
            type: String,
            enum: ['th1', 'th2', 'th3', 'th4', 'th5', 'th6', 'th7'],
            txtDescr: `Color theme of the element`,
            default: _ => 'th1',
        },
        isThInv: {
            name: 'isThInv',
            type: Boolean,
            txtDescr: `If is true, inversed color theme will be used`,
            default: _ => false,
        },
        isInf: {
            name: 'isInf',
            type: Boolean,
            txtDescr: `If is true, then infinite type is used`,
            default: _ => true,
        },
        isSpinner: {
            name: 'isSpinner',
            type: Boolean,
            txtDescr: `If is true, then spinnet type is used`,
            default: _ => false,
        },
        d: {
            name: 'd',
            type: Number,
            txtDescr: `Diameter`,
            txtError: `It should be non negative number`,
            validator: (v, sett) => v >= 0,
            enabled: (v, sett) => sett.isSpinner,
            default: _ => 50,
        },
        h: {
            name: 'h',
            type: Number,
            txtDescr: `Spinner line width`,
            txtError: `It should be non negative number`,
            validator: (v, sett) => v >= 0,
            enabled: (v, sett) => sett.isSpinner,
            default: _ => 3.5,
        },
        value: {
            name: 'value',
            type: Number,
            txtDescr: `Current progress value`,
            txtError: `It should be a number from 0 to 100`,
            validator: (v, sett) => v >= 0 && v <= 100,
            enabled: (v, sett) => !sett.isInf,
            default: _ => 50,
        },
        title: {
            name: 'title',
            type: String,
            txtDescr: `Title for progress`,
            default: _ => '',
        },
        titlePos: {
            name: 'titlePos',
            type: String,
            enum: ['top', 'right', 'bottom', 'left'],
            txtDescr: `Title position relative to progress indicator`,
            default: _ => 'top',
        },
        titleAlign: {
            name: 'Title alignment',
            type: String,
            enum: ['left', 'center', 'right'],
            txtDescr: `Title alignment in the string`,
            default: _ => 'center',
        },
    }
}
</script>

<template lang="pug">

div.dkbr-progress(
    :style=`{
        position: 'relative',
        flexDirection: titlePos=='top' || titlePos=='bottom' ? 'column' : 'row'
    }`)
    div.dkbr-progress__title(
        :style=`{
            order: titlePos=='right' || titlePos=='bottom' ? 2 : 0,
            alignSelf: titleAlign=='left' ? 'flex-start' : titleAlign=='center' ? 'center' : 'flex-end'
        }`)
        slot
            p {{ title }}
    md-progress-spinner.dkbr-progress__obj(
        v-if="isSpinner"
        :md-theme="isThInv ? th+'i' : th"
        :class=`{'md-primary': true,}`
        :md-mode="isInf ? 'indeterminate' : 'determinate'"
        :md-indeterminate="isInf"
        :md-diameter="d"
        :md-stroke="h"
        :md-value="value")
    md-progress-bar.dkbr-progress__obj(
        v-else
        :md-theme="isThInv ? th+'i' : th"
        :class=`{'md-primary': true,}`
        :md-mode="isInf ? 'indeterminate' : 'determinate'"
        :md-value="value")
</template>

<style lang="sass">
.dkbr-progress
    display: flex
    &__title
    &__obj
        order: 1
</style>



// WEBPACK FOOTER //
// src/progress/vue/Progress.vue